// Data API allows for immediate fetch of resources
import { useEffect, useState } from 'react';
import request from 'superagent';

export default function useDataApi(defaultUrl, initialData, defaultWhenNotFound) {
  const [data, setData] = useState(initialData);
  const [response, setResponse] = useState(initialData);
  // const [url, setUrl] = useState(initialUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const fetchData = async (url) => {
    setIsError(false);
    setIsLoading(true);
    try {
      const result = await request(url);
      setData(result.body);
      setResponse(result);
    } catch (error) {
      if (error.response.notFound && defaultWhenNotFound) {
        setData(defaultWhenNotFound);
        setIsError(false);
      }
      else {
        setIsError(error);
        setResponse(error.response);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData(defaultUrl);
  }, [defaultUrl]);

  const triggerRefresh = () => {
    fetchData(defaultUrl);
  };

  return [{ data, isLoading, isError, response }, { setData, fetchData, triggerRefresh }];
}



// WEBPACK FOOTER //
// ./src/utils/useDataApi.js